import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

import {useAuth0} from '@auth0/auth0-react';

import Loading from '@pb/kit-component-loading';

export const AuthCallback: React.FC = () => {
    const navigate = useNavigate();
    const {handleRedirectCallback, isLoading} = useAuth0();

    useEffect(() => {
        if (isLoading) {
            return;
        }

        const hasParams = window.location.search.includes('code=') && window.location.search.includes('state=');

        if (!hasParams) {
            navigate('/', {replace: true});
            return;
        }

        handleRedirectCallback(window.location.href)
            .then(result => {
                const returnToFromAppState = (result as {appState?: {returnTo?: string}})?.appState?.returnTo;
                navigate(returnToFromAppState || '/', {replace: true});
            })
            .catch(() => {
                navigate('/', {replace: true});
            });
    }, [handleRedirectCallback, isLoading, navigate]);

    return <Loading fast={true}/>;
};
